
import {Component, Vue} from 'vue-property-decorator'
import {getGoodsCategoryList, GoodsCategoryListDto } from '@/api/commodity'


@Component
export default class Rules extends Vue {
  showRules = false
  value = 0
  nowProduct(){}
  // relationId=''

  companyId='6194a03e003426000851d069'
  goodsList:GoodsCategoryListDto | Record<string, any> = {}


  created () {
    // this.relationId=this.$route.query.relationId as string

    this.getInfo()
  }

  getInfo(){
    const params = {
      companyId: '6194a03e003426000851d069',
      pageIndex: 1,
      categoryLevel:0,
      pageSize: 20,
      isPage: true
    }

    getGoodsCategoryList(params).then((res) => {
      this.goodsList = res.data.records || []
    })
  }
  // getInfo(){
  //   getGoodsCategoryList({ companyId: this.companyId, }).then(res => {
  //     this.goodsList = res.data[0] || {}
  //
  //   })
  //}

  // 点击左侧导航获取分类的详细商品分类
  showContent(index){
    this.nowProduct=this.goodsList[index].children
  }
  show() {
    this.showRules = true
  }
  close(){
    this.$router.go(0)
  }
  closeRules () {
    this.showRules = false
  }
}
